"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicFormConfigFormType = exports.DynamicFormConfigMultiCountryFields = exports.DynamicFormConfigCountryFields = exports.DynamicFormConfigFieldName = void 0;
var DynamicFormConfigFieldName;
(function (DynamicFormConfigFieldName) {
    DynamicFormConfigFieldName["email"] = "email";
    DynamicFormConfigFieldName["businessName"] = "businessName";
    DynamicFormConfigFieldName["firstName"] = "firstName";
    DynamicFormConfigFieldName["lastName"] = "lastName";
    DynamicFormConfigFieldName["birthdayAt"] = "birthdayAt";
    DynamicFormConfigFieldName["businessAddressStreet"] = "businessAddressStreet";
    DynamicFormConfigFieldName["businessAddressHouseNumber"] = "businessAddressHouseNumber";
    DynamicFormConfigFieldName["businessAddressSuiteIdentifier"] = "businessAddressSuiteIdentifier";
    DynamicFormConfigFieldName["businessAddressFloorIdentifier"] = "businessAddressFloorIdentifier";
    DynamicFormConfigFieldName["businessAddressDistrictName"] = "businessAddressDistrictName";
    DynamicFormConfigFieldName["businessAddressPOB"] = "businessAddressPOB";
    DynamicFormConfigFieldName["businessAddressZIP"] = "businessAddressZIP";
    DynamicFormConfigFieldName["businessAddressCity"] = "businessAddressCity";
    DynamicFormConfigFieldName["headquartersAddressStreet"] = "headquartersAddressStreet";
    DynamicFormConfigFieldName["headquartersAddressHouseNumber"] = "headquartersAddressHouseNumber";
    DynamicFormConfigFieldName["headquartersAddressSuiteIdentifier"] = "headquartersAddressSuiteIdentifier";
    DynamicFormConfigFieldName["headquartersAddressFloorIdentifier"] = "headquartersAddressFloorIdentifier";
    DynamicFormConfigFieldName["headquartersAddressDistrictName"] = "headquartersAddressDistrictName";
    DynamicFormConfigFieldName["headquartersAddressPOB"] = "headquartersAddressPOB";
    DynamicFormConfigFieldName["headquartersAddressZIP"] = "headquartersAddressZIP";
    DynamicFormConfigFieldName["headquartersAddressCity"] = "headquartersAddressCity";
    DynamicFormConfigFieldName["correspondenceAddressIsDifferentFromHqAddress"] = "correspondenceAddressIsDifferentFromHqAddress";
    DynamicFormConfigFieldName["correspondenceAddressStreet"] = "correspondenceAddressStreet";
    DynamicFormConfigFieldName["correspondenceAddressHouseNumber"] = "correspondenceAddressHouseNumber";
    DynamicFormConfigFieldName["correspondenceAddressSuiteIdentifier"] = "correspondenceAddressSuiteIdentifier";
    DynamicFormConfigFieldName["correspondenceAddressFloorIdentifier"] = "correspondenceAddressFloorIdentifier";
    DynamicFormConfigFieldName["correspondenceAddressDistrictName"] = "correspondenceAddressDistrictName";
    DynamicFormConfigFieldName["correspondenceAddressPOB"] = "correspondenceAddressPOB";
    DynamicFormConfigFieldName["correspondenceAddressZIP"] = "correspondenceAddressZIP";
    DynamicFormConfigFieldName["correspondenceAddressCity"] = "correspondenceAddressCity";
    DynamicFormConfigFieldName["bankAccountCountryId"] = "bankAccountCountryId";
    DynamicFormConfigFieldName["bankAccountHolderName"] = "bankAccountHolderName";
    DynamicFormConfigFieldName["nationalityCountryId"] = "nationalityCountryId";
    DynamicFormConfigFieldName["residenceCountryId"] = "residenceCountryId";
    DynamicFormConfigFieldName["occupation"] = "occupation";
    DynamicFormConfigFieldName["companyIdNumber"] = "companyIdNumber";
    DynamicFormConfigFieldName["taxIdentificationNumber"] = "taxIdentificationNumber";
    DynamicFormConfigFieldName["vatNumber"] = "vatNumber";
    DynamicFormConfigFieldName["identifiedPersonNumber"] = "identifiedPersonNumber";
    DynamicFormConfigFieldName["uboDeclaration"] = "uboDeclaration";
    DynamicFormConfigFieldName["taxResidenceCountryId"] = "taxResidenceCountryId";
    DynamicFormConfigFieldName["invoiceCountryId"] = "invoiceCountryId";
    DynamicFormConfigFieldName["birthplace"] = "birthplace";
    DynamicFormConfigFieldName["birthplaceCity"] = "birthplaceCity";
    DynamicFormConfigFieldName["birthplaceCountryId"] = "birthplaceCountryId";
    DynamicFormConfigFieldName["basedIn"] = "basedIn";
    DynamicFormConfigFieldName["transportCountries"] = "transportCountries";
    DynamicFormConfigFieldName["accountNumber"] = "accountNumber";
    DynamicFormConfigFieldName["iban"] = "iban";
    DynamicFormConfigFieldName["abaRouting"] = "abaRouting";
    DynamicFormConfigFieldName["bicSwift"] = "bicSwift";
    DynamicFormConfigFieldName["permanentEstablishmentInAnotherCountry"] = "permanentEstablishmentInAnotherCountry";
    DynamicFormConfigFieldName["permanentEstablishmentAddressStreet"] = "permanentEstablishmentAddressStreet";
    DynamicFormConfigFieldName["permanentEstablishmentAddressHouseNumber"] = "permanentEstablishmentAddressHouseNumber";
    DynamicFormConfigFieldName["permanentEstablishmentAddressSuiteIdentifier"] = "permanentEstablishmentAddressSuiteIdentifier";
    DynamicFormConfigFieldName["permanentEstablishmentAddressFloorIdentifier"] = "permanentEstablishmentAddressFloorIdentifier";
    DynamicFormConfigFieldName["permanentEstablishmentAddressDistrictName"] = "permanentEstablishmentAddressDistrictName";
    DynamicFormConfigFieldName["permanentEstablishmentAddressPOB"] = "permanentEstablishmentAddressPOB";
    DynamicFormConfigFieldName["permanentEstablishmentAddressZIP"] = "permanentEstablishmentAddressZIP";
    DynamicFormConfigFieldName["permanentEstablishmentAddressCity"] = "permanentEstablishmentAddressCity";
    DynamicFormConfigFieldName["permanentEstablishmentAddressCountryId"] = "permanentEstablishmentAddressCountryId";
})(DynamicFormConfigFieldName || (exports.DynamicFormConfigFieldName = DynamicFormConfigFieldName = {}));
exports.DynamicFormConfigCountryFields = [
    DynamicFormConfigFieldName.bankAccountCountryId,
    DynamicFormConfigFieldName.nationalityCountryId,
    DynamicFormConfigFieldName.residenceCountryId,
    DynamicFormConfigFieldName.taxResidenceCountryId,
    DynamicFormConfigFieldName.invoiceCountryId,
    DynamicFormConfigFieldName.birthplaceCountryId,
    DynamicFormConfigFieldName.permanentEstablishmentAddressCountryId,
    DynamicFormConfigFieldName.basedIn,
];
exports.DynamicFormConfigMultiCountryFields = [DynamicFormConfigFieldName.transportCountries];
var DynamicFormConfigFormType;
(function (DynamicFormConfigFormType) {
    DynamicFormConfigFormType["BILLING_INFORMATION"] = "BILLING_INFORMATION";
    DynamicFormConfigFormType["COOPERATION_AGREEMENT"] = "COOPERATION_AGREEMENT";
})(DynamicFormConfigFormType || (exports.DynamicFormConfigFormType = DynamicFormConfigFormType = {}));
//# sourceMappingURL=SaveCooperationAgreementInputDynamicForm.js.map